import { render, staticRenderFns } from "./ManageCriteriaListModal.vue?vue&type=template&id=66a106fa&"
import script from "./ManageCriteriaListModal.vue?vue&type=script&lang=js&"
export * from "./ManageCriteriaListModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports